import { Suspense } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';

import Loading from '$components/shared/components/Loading';
import { lazyReactNaiveRetry } from '$utils/LazyUtils';

const MainComponent = lazyReactNaiveRetry(() => import('./MainComponent'));

const Main = withAuthenticationRequired(MainComponent, {
  onRedirecting: () => <Loading />,
});

const MainComponentLazy = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Main />
    </Suspense>
  );
};

export default MainComponentLazy;
